<!--
 * @Author: lan.h
 * @Date: 2022-02-14 16:47:32
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-28 09:38:25
 * @Description: 五个实体
-->
<template>
  <div>
    <div class="entity-list">
      <div class="e-item" v-for="m in item.entity" :key="m.uid" @click.stop="goEntity(m)">
        <div class="e-content">
          <div class="e-img">
            <img v-if="m.logoPath" :src="m.logoPath | logo_show" :alt="m.shortName">
          </div>
          <h1 class="e-name over-p1">{{m.shortName}}</h1>

          <EntityAttention :entityItem="m" :entityType="m.type">
            <a class="e-detail" slot="slot1">添加关注</a>
            <a class="e-detail" slot="slot2">已关注</a>
          </EntityAttention>
          <div class="summary">
            <p class="over-p5">{{m.description}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="e-item-name">
      <span>根据投融资报道智能推荐</span>
      <div class="e-item-dec">数据由 <img :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙" @click="haddleApplyTry2(32)"> 提供支持</div>
    </div>
  </div>
</template>

<script>
import EntityAttention from '../../DataList/components/EntityAttention.vue'
export default {
  components: {
    EntityAttention,
  },
  inject: ['haddleApplyTry2'],
  props: ['item'],
  methods: {
    goEntity(a) {
      //跳转实体详情
      if (a.type == 0) {
        const href = this.$store.state.index_path + '/companyDetail/' + a.uid
        window.open(href, '_blank')
      } else if (a.type == 1) {
        const href = this.$store.state.index_path + '/orgDetail/' + a.uid
        window.open(href, '_blank')
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.entity-list
  display flex
  flex-flow row nowrap
  justify-content space-between
  box-shadow unset !important
  overflow hidden
  padding 4px
  .e-item
    padding 0 0 18px 0
    .e-content
      width 132px
      height 170px
      transition all 0.5s
      cursor pointer
      padding 14px
      position relative
      background #FFFFFF
      box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.1)
      box-sizing border-box
      .e-img
        height 100px
        width 100%
        display flex
        justify-content center
        align-items center
        img
          max-width 100%
          max-height 100%
      .e-name
        font-size 14px
        color #333333
        text-align center
        margin-top 10px
        font-weight 500
      .e-detail
        z-index 3
        position absolute
        bottom -14px
        left 50%
        margin-left -44px
        width 88px
        height 28px
        text-align center
        background #FFF5F2
        box-shadow 0px 2px 8px 0px rgba(211, 81, 38, 0.15)
        font-size 12px
        color #FA7A50
        line-height 28px
      .summary
        z-index 1
        color #fff
        padding 30px 20px 20px 20px
        position absolute
        width 100%
        height 100%
        left 0
        top 0
        opacity 0
        transform translate3d(0, 50px, 0)
        transition all 0.5s
        display flex
        flex-direction column
        align-items center
        margin-top 0
        p
          width 100%
          font-size 14px
          line-height 20px
          word-break break-all
    &:hover
      .summary
        background #fc9c7c
        transform translate3d(0, 0, 0)
        opacity 1
      .e-detail
        background-color #FA5A00
        color #fff
.e-item-name
  margin-top 16px
  background #F9F9F9
  height 31px
  display flex
  align-items center
  flex-flow row nowrap
  justify-content space-between
  padding 7px 20px
  font-size 12px
  color #B0B0B0
  .e-item-dec
    display flex
    align-items center
    justify-content flex-end
    img
      height 16px
      margin 0 2px
      opacity 0.6
      cursor pointer
      &:hover
        opacity 0.8
</style>